import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Button } from "../components/ui/Button";

const Wrap = styled.div`
  padding: 48px 0;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 32px;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.text.heading};
`;

const Sub = styled.p`
  margin: 12px 0 0;
  color: ${({ theme }) => theme.colors.text.body};
`;

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <Wrap>
      <Title>{t("notFound.title")}</Title>
      <Sub>{t("notFound.description")}</Sub>
      <div style={{ marginTop: 18 }}>
        <Link to="/dashboard" style={{ textDecoration: "none" }}>
          <Button>{t("notFound.goToDashboard")}</Button>
        </Link>
      </div>
    </Wrap>
  );
}
